import * as ObjectSegFilterTypes from 'customer-data-filters-ui/converters/objectSeg/ObjectSegFilterTypes';
import * as OperatorTypes from '../ObjectSegOperatorTypes';
import * as Operators from 'customer-data-filters-ui/filterQueryFormat/operator/Operators';
import get from 'transmute/get';
import invariant from 'react-utils/invariant';
import protocol from 'transmute/protocol';
import { toMultipleRefinementFilter } from '../multipleRefinementsUtils';
const _toPageViewFilter = (operatorName, operator, hasEnableTracking = false) => {
  let enableTrackingProperty;
  if (hasEnableTracking) {
    enableTrackingProperty = {
      enableTracking: !!(operator !== null && operator !== void 0 && operator.enableTracking)
    };
  }
  const filter = Object.assign({}, enableTrackingProperty, {
    filterType: ObjectSegFilterTypes.PAGE_VIEW,
    operator: operatorName,
    pageUrl: get('value', operator)
  });
  return Object.assign({}, filter, toMultipleRefinementFilter(operator));
};
const invalidOperator = operator => {
  invariant(false, 'cannot convert Operator "%s" to Page View filter', operator.name);
};
const toPageViewFilter = protocol({
  name: 'toPageViewFilter',
  args: [protocol.TYPE],
  fallback: invalidOperator
});
toPageViewFilter.implement(Operators.PageViewEqual, operator => _toPageViewFilter(OperatorTypes.HAS_PAGEVIEW_EQ, operator, true));
toPageViewFilter.implement(Operators.PageViewContain, operator => _toPageViewFilter(OperatorTypes.HAS_PAGEVIEW_CONTAINS, operator));
toPageViewFilter.implement(Operators.PageViewMatchRegex, operator => _toPageViewFilter(OperatorTypes.HAS_PAGEVIEW_MATCHES_REGEX, operator));
toPageViewFilter.implement(Operators.PageViewNotEqual, operator => _toPageViewFilter(OperatorTypes.NOT_HAS_PAGEVIEW_EQ, operator, true));
toPageViewFilter.implement(Operators.PageViewNotContain, operator => _toPageViewFilter(OperatorTypes.NOT_HAS_PAGEVIEW_CONTAINS, operator));
toPageViewFilter.implement(Operators.PageViewNotMatchRegex, operator => _toPageViewFilter(OperatorTypes.NOT_HAS_PAGEVIEW_MATCHES_REGEX, operator));
export default toPageViewFilter;